var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("SModalCentered", {
    attrs: {
      title: _vm.$t("teamRequestDetail.modal.manager.approveTeamRequest.title"),
      isOpen: _vm.isOpen,
      closeModal: _vm.handleClose,
      customProps: _vm.customModalProps,
    },
    scopedSlots: _vm._u([
      {
        key: "body",
        fn: function () {
          return [
            _c("div", { staticClass: "text-body-1 text--text" }, [
              _vm._v(
                _vm._s(
                  _vm.$t(
                    "teamRequestDetail.modal.manager.approveTeamRequest.body"
                  )
                )
              ),
            ]),
          ]
        },
        proxy: true,
      },
      {
        key: "footer",
        fn: function () {
          return [
            _c(
              "v-row",
              { attrs: { "no-gutters": "" } },
              [
                _c(
                  "v-col",
                  { staticClass: "mr-6" },
                  [
                    _c("SButton", {
                      attrs: {
                        action: _vm.handleClose,
                        btnStyle: "tertiary",
                        sText: _vm.$t(
                          "teamRequestDetail.modal.manager.approveTeamRequest.primaryButtonText"
                        ),
                        disabled: _vm.loading,
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "v-col",
                  { staticClass: "mr-6" },
                  [
                    _vm.loading
                      ? [
                          _c(
                            "div",
                            {
                              staticClass: "d-flex align-center justify-center",
                              staticStyle: { "min-height": "40px" },
                            },
                            [
                              _c("v-progress-circular", {
                                staticClass: "mr-2",
                                attrs: {
                                  color: "primary",
                                  indeterminate: "",
                                  width: 4,
                                  size: "24",
                                },
                              }),
                              _vm._v(" "),
                              _c("span", [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t(
                                      "teamRequestDetail.modal.manager.approveTeamRequest.processing"
                                    )
                                  )
                                ),
                              ]),
                            ],
                            1
                          ),
                        ]
                      : [
                          _c("SButton", {
                            attrs: {
                              action: _vm.handleAccept,
                              sText: _vm.$t(
                                "teamRequestDetail.modal.manager.approveTeamRequest.secondaryButtonText"
                              ),
                            },
                          }),
                        ],
                  ],
                  2
                ),
              ],
              1
            ),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }